module.exports = __webpack_public_path__ + "img/39012-010.f1234983.jpg";